module.exports = __webpack_public_path__ + "img/icon_step.dbfbe0a7.png";